import { render, staticRenderFns } from "./Challenge2.vue?vue&type=template&id=bb0c9b30&scoped=true&lang=pug&"
import script from "./Challenge2.vue?vue&type=script&lang=ts&"
export * from "./Challenge2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c9b30",
  null
  
)

export default component.exports